import UIkit from "uikit";
import store from "@/store/index";
import { AxiosResponse } from "axios";
import { StoreModule } from "@/store/types";
import { GlobalActions } from "@/store/modules/global/types";
import { Roles } from "@/models/roles";
import { UserActions } from "@/store/modules/user/types";

export class GeocodeError extends Error {
  static popup(message: string) {
    UIkit.notification({ message: message, status: "danger" });
  }
}

export class APIError extends Error {
  constructor(message: string, statusCode?: number) {
    super(message)
    this.statusCode = statusCode
  }
  public statusCode?: number;
  static popup(message: string) {
    UIkit.notification({ message: message, status: "danger" });
  }
  static restricted() {
    UIkit.notification({
      message:
        "This customer is not associated with your account. Please contact the administrator if this is an error.",
      status: "danger",
    });
  }
}

export class PermissionsError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    UIkit.notification({
      message: statusCode + " : " + message,
      status: "danger"
    });
  }
}

export class LoginError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    UIkit.notification({
      message: statusCode + " : " + message,
      status: "danger"
    });
  }
}
export class GenericError extends Error {
  static popup(message: string) {
    UIkit.notification({ message: message, status: "danger" });
  }
}

export class NotFoundError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    UIkit.notification({
      message: statusCode + " : " + message,
      status: "danger"
    });
  }
}

export class BadRequest extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    UIkit.notification({
      message: statusCode + " : " + message,
      status: "danger"
    });
  }
}


export class FrankfordError extends Error {
  protected config: object;
  protected data: string;
  protected headers: object;
  protected request: XMLHttpRequest;
  protected status: number;
  protected statusText: string;
  constructor(response: AxiosResponse<any>) {
    super(response["data"]);
    this.name = this.constructor.name;
    this.config = response.config;
    this.data = response.data;
    this.headers = response.headers;
    this.request = response.request;
    this.status = response.status;
    this.statusText = response.statusText;
  }
}

export class AuthError extends Error {
  constructor(message: string, statusCode?: number) {
    super(message);
    this.statusCode = statusCode ? statusCode : 401;
  }
  public statusCode: number;
  static logout(): void {
    store.dispatch(StoreModule.Global + GlobalActions.AddLoggedIn, false);
    store.dispatch(StoreModule.User + UserActions.AddUser, null);
    UIkit.notification({
      message: "Your session has expired. Please login again.",
      status: "danger"
    });
    window.location.replace(`${process.env.VUE_APP_LOGIN_URL}?returnURL=${process.env.VUE_APP_URL}`)
  }
}